virtual function void {{ writeFunctionName }}({{ relations.sequenceItemHandle.klass.type }} {{ relations.sequenceItemHandle.shortName }}{{#each relations.sequenceItemHandle.iterationPropertiesList.last.iterationVariables lc=true delimeter=", "}}int {{ . }}{{/each}});
  // <TODO> store item details in instance variables.
  // Then call cg.sample();
endfunction
